<mak-notification
  [data]="activeNotification"
  (onNotificationExpired)="hideNotification()"></mak-notification>


<span (click)="dummyPush()"></span>
